module.exports = __webpack_public_path__ + "img/Rectangle4.81f9ff6.png";